// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"505":"407846e6","654":"582c1146","667":"186afee4"}[chunkId] + ".css";
};